module.exports = __webpack_public_path__ + "static/media/23.885130fe.jpg";